import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import api from "@/lib/api";
import PageHero from "@/components/public/PageHero";

const DEFAULT_TITLE = "Cresent Bank | Global Financial Markets";

function setMeta(attr, key, content) {
  if (!content) return null;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  const created = !el;
  if (!el) { el = document.createElement("meta"); el.setAttribute(attr, key); document.head.appendChild(el); }
  const prev = el.getAttribute("content");
  el.setAttribute("content", content);
  return { el, prev, created };
}

export default function CustomPage() {
  const { slug } = useParams();
  const [page, setPage] = useState(null);
  const [status, setStatus] = useState("loading");

  useEffect(() => {
    setStatus("loading");
    api.get(`/pages/slug/${slug}`)
      .then((r) => { setPage(r.data); setStatus("ok"); })
      .catch(() => setStatus("notfound"));
  }, [slug]);

  useEffect(() => {
    if (status !== "ok" || !page) return;
    const prevTitle = document.title;
    document.title = page.seo_title || page.title || DEFAULT_TITLE;
    const applied = [
      setMeta("name", "description", page.seo_description),
      setMeta("property", "og:title", page.seo_title || page.title),
      setMeta("property", "og:description", page.seo_description),
      setMeta("property", "og:image", page.og_image),
      setMeta("property", "og:type", "article"),
    ].filter(Boolean);
    return () => {
      document.title = prevTitle;
      applied.forEach(({ el, prev, created }) => {
        if (created) el.remove();
        else if (prev !== null) el.setAttribute("content", prev);
      });
    };
  }, [status, page]);

  if (status === "loading") {
    return <div className="cb-container py-32 text-center text-slate-400" data-testid="page-loading">Loading…</div>;
  }
  if (status === "notfound") {
    return (
      <div className="cb-container py-32 text-center" data-testid="page-notfound">
        <h1 className="font-serif text-3xl text-white mb-3">Page not found</h1>
        <p className="text-slate-400 mb-6">This page may have been moved or unpublished.</p>
        <Link to="/" className="btn-gold px-5 py-2.5 text-sm">Back to Home</Link>
      </div>
    );
  }

  const hasBody = !!String(page.body || "").trim();

  return (
    <div data-testid="custom-page">
      <PageHero overline={page.overline || "Cresent Bank"} title={page.title} subtitle={page.subtitle} image={page.image} />
      <section className="mk-panel bg-[#05070D] py-14">
        <div className="cb-container max-w-3xl">
          {hasBody
            ? <article className="cb-prose text-slate-300" data-testid="custom-page-body" dangerouslySetInnerHTML={{ __html: page.body }} />
            : <p className="text-slate-400">This page has no content yet.</p>}
        </div>
      </section>
    </div>
  );
}
